// AUTO-GENERATED by isa/codegen.py — do not edit directly.
// Source of truth: spec/isa.json

export const Op = Object.freeze({
    // Core (0–97)
    HLT: 0,
    MOV_REG_REG: 1,
    MOV_REG_ADDR: 2,
    MOV_REG_REGADDR: 3,
    MOV_ADDR_REG: 4,
    MOV_REGADDR_REG: 5,
    MOV_REG_CONST: 6,
    MOV_ADDR_CONST: 7,
    MOV_REGADDR_CONST: 8,
    ADD_REG_REG: 10,
    ADD_REG_REGADDR: 11,
    ADD_REG_ADDR: 12,
    ADD_REG_CONST: 13,
    SUB_REG_REG: 14,
    SUB_REG_REGADDR: 15,
    SUB_REG_ADDR: 16,
    SUB_REG_CONST: 17,
    INC_REG: 18,
    DEC_REG: 19,
    CMP_REG_REG: 20,
    CMP_REG_REGADDR: 21,
    CMP_REG_ADDR: 22,
    CMP_REG_CONST: 23,
    JMP_REG: 30,
    JMP_ADDR: 31,
    JC_REG: 32,
    JC_ADDR: 33,
    JNC_REG: 34,
    JNC_ADDR: 35,
    JZ_REG: 36,
    JZ_ADDR: 37,
    JNZ_REG: 38,
    JNZ_ADDR: 39,
    JA_REG: 40,
    JA_ADDR: 41,
    JNA_REG: 42,
    JNA_ADDR: 43,
    PUSH_REG: 50,
    PUSH_REGADDR: 51,
    PUSH_ADDR: 52,
    PUSH_CONST: 53,
    POP_REG: 54,
    CALL_REG: 55,
    CALL_ADDR: 56,
    RET: 57,
    MUL_REG: 60,
    MUL_REGADDR: 61,
    MUL_ADDR: 62,
    MUL_CONST: 63,
    DIV_REG: 64,
    DIV_REGADDR: 65,
    DIV_ADDR: 66,
    DIV_CONST: 67,
    AND_REG_REG: 70,
    AND_REG_REGADDR: 71,
    AND_REG_ADDR: 72,
    AND_REG_CONST: 73,
    OR_REG_REG: 74,
    OR_REG_REGADDR: 75,
    OR_REG_ADDR: 76,
    OR_REG_CONST: 77,
    XOR_REG_REG: 78,
    XOR_REG_REGADDR: 79,
    XOR_REG_ADDR: 80,
    XOR_REG_CONST: 81,
    NOT_REG: 82,
    SHL_REG_REG: 90,
    SHL_REG_REGADDR: 91,
    SHL_REG_ADDR: 92,
    SHL_REG_CONST: 93,
    SHR_REG_REG: 94,
    SHR_REG_REGADDR: 95,
    SHR_REG_ADDR: 96,
    SHR_REG_CONST: 97,

    // FP (128–162)
    FMOV_FP_ADDR: 128,
    FMOV_FP_REGADDR: 129,
    FMOV_ADDR_FP: 130,
    FMOV_REGADDR_FP: 131,
    FADD_FP_ADDR: 132,
    FADD_FP_REGADDR: 133,
    FSUB_FP_ADDR: 134,
    FSUB_FP_REGADDR: 135,
    FMUL_FP_ADDR: 136,
    FMUL_FP_REGADDR: 137,
    FDIV_FP_ADDR: 138,
    FDIV_FP_REGADDR: 139,
    FCMP_FP_ADDR: 140,
    FCMP_FP_REGADDR: 141,
    FABS_FP: 142,
    FNEG_FP: 143,
    FSQRT_FP: 144,
    FMOV_RR: 145,
    FCVT_FP_FP: 146,
    FITOF_FP_GPR: 147,
    FFTOI_GPR_FP: 148,
    FSTAT_GPR: 149,
    FCFG_GPR: 150,
    FSCFG_GPR: 151,
    FCLR: 152,
    FADD_RR: 153,
    FSUB_RR: 154,
    FMUL_RR: 155,
    FDIV_RR: 156,
    FCMP_RR: 157,
    FCLASS_GPR_FP: 158,
    FMADD_FP_FP_ADDR: 159,
    FMADD_FP_FP_REGADDR: 160,
    FMOV_FP_IMM8: 161,
    FMOV_FP_IMM16: 162,

    // VU (163–183)
    VSET_IMM16: 163,
    VSET_GPR: 164,
    VSET_MEM: 165,
    VSET_MEMI: 166,
    VFSTAT: 167,
    VFCLR: 168,
    VWAIT: 169,
    VADD: 170,
    VSUB: 171,
    VMUL: 172,
    VDIV: 173,
    VMAX: 174,
    VMIN: 175,
    VDOT: 176,
    VSQRT: 177,
    VNEG: 178,
    VABS: 179,
    VCMP: 180,
    VSEL: 181,
    VMOV: 182,
    VCVT: 183,
    VGATHER: 184,
    VSCATTER: 185,
    VFMADD: 186,
    VEXP: 187,

    // MU (188–194)
    MSET_IMM16: 188,
    MSET_GPR: 189,
    MFSTAT: 190,
    MFCLR: 191,
    MWAIT: 192,
    MMUL: 193,
    MMAD: 194,
});

// ── Instruction data ─────────────────────────────────────────────────
// Each entry: [op_name, opcode, mnemonic, operands, cost, formatDep]

export const ISA_DATA = [
    ["HLT", 0, "HLT", [], 0, false],
    ["MOV_REG_REG", 1, "MOV", ["reg", "reg"], 1, false],
    ["MOV_REG_ADDR", 2, "MOV", ["reg", "mem"], 2, false],
    ["MOV_REG_REGADDR", 3, "MOV", ["reg", "regaddr"], 2, false],
    ["MOV_ADDR_REG", 4, "MOV", ["mem", "reg"], 2, false],
    ["MOV_REGADDR_REG", 5, "MOV", ["regaddr", "reg"], 2, false],
    ["MOV_REG_CONST", 6, "MOV", ["reg", "imm"], 1, false],
    ["MOV_ADDR_CONST", 7, "MOV", ["mem", "imm"], 2, false],
    ["MOV_REGADDR_CONST", 8, "MOV", ["regaddr", "imm"], 2, false],
    ["ADD_REG_REG", 10, "ADD", ["reg_arith", "reg_arith"], 1, false],
    ["ADD_REG_REGADDR", 11, "ADD", ["reg_arith", "regaddr"], 3, false],
    ["ADD_REG_ADDR", 12, "ADD", ["reg_arith", "mem"], 3, false],
    ["ADD_REG_CONST", 13, "ADD", ["reg_arith", "imm"], 1, false],
    ["SUB_REG_REG", 14, "SUB", ["reg_arith", "reg_arith"], 1, false],
    ["SUB_REG_REGADDR", 15, "SUB", ["reg_arith", "regaddr"], 3, false],
    ["SUB_REG_ADDR", 16, "SUB", ["reg_arith", "mem"], 3, false],
    ["SUB_REG_CONST", 17, "SUB", ["reg_arith", "imm"], 1, false],
    ["INC_REG", 18, "INC", ["reg_arith"], 1, false],
    ["DEC_REG", 19, "DEC", ["reg_arith"], 1, false],
    ["CMP_REG_REG", 20, "CMP", ["reg_arith", "reg_arith"], 1, false],
    ["CMP_REG_REGADDR", 21, "CMP", ["reg_arith", "regaddr"], 3, false],
    ["CMP_REG_ADDR", 22, "CMP", ["reg_arith", "mem"], 3, false],
    ["CMP_REG_CONST", 23, "CMP", ["reg_arith", "imm"], 1, false],
    ["JMP_REG", 30, "JMP", ["reg_gpr"], 1, false],
    ["JMP_ADDR", 31, "JMP", ["imm"], 1, false],
    ["JC_REG", 32, "JC", ["reg_gpr"], 1, false],
    ["JC_ADDR", 33, "JC", ["imm"], 1, false],
    ["JNC_REG", 34, "JNC", ["reg_gpr"], 1, false],
    ["JNC_ADDR", 35, "JNC", ["imm"], 1, false],
    ["JZ_REG", 36, "JZ", ["reg_gpr"], 1, false],
    ["JZ_ADDR", 37, "JZ", ["imm"], 1, false],
    ["JNZ_REG", 38, "JNZ", ["reg_gpr"], 1, false],
    ["JNZ_ADDR", 39, "JNZ", ["imm"], 1, false],
    ["JA_REG", 40, "JA", ["reg_gpr"], 1, false],
    ["JA_ADDR", 41, "JA", ["imm"], 1, false],
    ["JNA_REG", 42, "JNA", ["reg_gpr"], 1, false],
    ["JNA_ADDR", 43, "JNA", ["imm"], 1, false],
    ["PUSH_REG", 50, "PUSH", ["reg_stack"], 2, false],
    ["PUSH_REGADDR", 51, "PUSH", ["regaddr"], 4, false],
    ["PUSH_ADDR", 52, "PUSH", ["mem"], 4, false],
    ["PUSH_CONST", 53, "PUSH", ["imm"], 2, false],
    ["POP_REG", 54, "POP", ["reg_stack"], 2, false],
    ["CALL_REG", 55, "CALL", ["reg_gpr"], 2, false],
    ["CALL_ADDR", 56, "CALL", ["imm"], 2, false],
    ["RET", 57, "RET", [], 2, false],
    ["MUL_REG", 60, "MUL", ["reg_gpr"], 2, false],
    ["MUL_REGADDR", 61, "MUL", ["regaddr"], 4, false],
    ["MUL_ADDR", 62, "MUL", ["mem"], 4, false],
    ["MUL_CONST", 63, "MUL", ["imm"], 2, false],
    ["DIV_REG", 64, "DIV", ["reg_gpr"], 2, false],
    ["DIV_REGADDR", 65, "DIV", ["regaddr"], 4, false],
    ["DIV_ADDR", 66, "DIV", ["mem"], 4, false],
    ["DIV_CONST", 67, "DIV", ["imm"], 2, false],
    ["AND_REG_REG", 70, "AND", ["reg_gpr", "reg_gpr"], 1, false],
    ["AND_REG_REGADDR", 71, "AND", ["reg_gpr", "regaddr"], 3, false],
    ["AND_REG_ADDR", 72, "AND", ["reg_gpr", "mem"], 3, false],
    ["AND_REG_CONST", 73, "AND", ["reg_gpr", "imm"], 1, false],
    ["OR_REG_REG", 74, "OR", ["reg_gpr", "reg_gpr"], 1, false],
    ["OR_REG_REGADDR", 75, "OR", ["reg_gpr", "regaddr"], 3, false],
    ["OR_REG_ADDR", 76, "OR", ["reg_gpr", "mem"], 3, false],
    ["OR_REG_CONST", 77, "OR", ["reg_gpr", "imm"], 1, false],
    ["XOR_REG_REG", 78, "XOR", ["reg_gpr", "reg_gpr"], 1, false],
    ["XOR_REG_REGADDR", 79, "XOR", ["reg_gpr", "regaddr"], 3, false],
    ["XOR_REG_ADDR", 80, "XOR", ["reg_gpr", "mem"], 3, false],
    ["XOR_REG_CONST", 81, "XOR", ["reg_gpr", "imm"], 1, false],
    ["NOT_REG", 82, "NOT", ["reg_gpr"], 1, false],
    ["SHL_REG_REG", 90, "SHL", ["reg_gpr", "reg_gpr"], 1, false],
    ["SHL_REG_REGADDR", 91, "SHL", ["reg_gpr", "regaddr"], 3, false],
    ["SHL_REG_ADDR", 92, "SHL", ["reg_gpr", "mem"], 3, false],
    ["SHL_REG_CONST", 93, "SHL", ["reg_gpr", "imm"], 1, false],
    ["SHR_REG_REG", 94, "SHR", ["reg_gpr", "reg_gpr"], 1, false],
    ["SHR_REG_REGADDR", 95, "SHR", ["reg_gpr", "regaddr"], 3, false],
    ["SHR_REG_ADDR", 96, "SHR", ["reg_gpr", "mem"], 3, false],
    ["SHR_REG_CONST", 97, "SHR", ["reg_gpr", "imm"], 1, false],
];

export const ISA_FP_DATA = [
    ["FMOV_FP_ADDR", 128, "FMOV", ["fp_reg", "mem"], 0, true],
    ["FMOV_FP_REGADDR", 129, "FMOV", ["fp_reg", "regaddr"], 0, true],
    ["FMOV_ADDR_FP", 130, "FMOV", ["mem", "fp_reg"], 0, true],
    ["FMOV_REGADDR_FP", 131, "FMOV", ["regaddr", "fp_reg"], 0, true],
    ["FADD_FP_ADDR", 132, "FADD", ["fp_reg", "mem"], 2, true],
    ["FADD_FP_REGADDR", 133, "FADD", ["fp_reg", "regaddr"], 2, true],
    ["FSUB_FP_ADDR", 134, "FSUB", ["fp_reg", "mem"], 2, true],
    ["FSUB_FP_REGADDR", 135, "FSUB", ["fp_reg", "regaddr"], 2, true],
    ["FMUL_FP_ADDR", 136, "FMUL", ["fp_reg", "mem"], 2, true],
    ["FMUL_FP_REGADDR", 137, "FMUL", ["fp_reg", "regaddr"], 2, true],
    ["FDIV_FP_ADDR", 138, "FDIV", ["fp_reg", "mem"], 3, true],
    ["FDIV_FP_REGADDR", 139, "FDIV", ["fp_reg", "regaddr"], 3, true],
    ["FCMP_FP_ADDR", 140, "FCMP", ["fp_reg", "mem"], 2, true],
    ["FCMP_FP_REGADDR", 141, "FCMP", ["fp_reg", "regaddr"], 2, true],
    ["FABS_FP", 142, "FABS", ["fp_reg"], 2, false],
    ["FNEG_FP", 143, "FNEG", ["fp_reg"], 2, false],
    ["FSQRT_FP", 144, "FSQRT", ["fp_reg"], 3, false],
    ["FMOV_RR", 145, "FMOV", ["fp_reg", "fp_reg"], 1, false],
    ["FCVT_FP_FP", 146, "FCVT", ["fp_reg", "fp_reg"], 2, false],
    ["FITOF_FP_GPR", 147, "FITOF", ["fp_reg", "reg_gpr"], 2, false],
    ["FFTOI_GPR_FP", 148, "FFTOI", ["reg_gpr", "fp_reg"], 2, false],
    ["FSTAT_GPR", 149, "FSTAT", ["reg_gpr"], 1, false],
    ["FCFG_GPR", 150, "FCFG", ["reg_gpr"], 1, false],
    ["FSCFG_GPR", 151, "FSCFG", ["reg_gpr"], 1, false],
    ["FCLR", 152, "FCLR", [], 1, false],
    ["FADD_RR", 153, "FADD", ["fp_reg", "fp_reg"], 2, false],
    ["FSUB_RR", 154, "FSUB", ["fp_reg", "fp_reg"], 2, false],
    ["FMUL_RR", 155, "FMUL", ["fp_reg", "fp_reg"], 2, false],
    ["FDIV_RR", 156, "FDIV", ["fp_reg", "fp_reg"], 3, false],
    ["FCMP_RR", 157, "FCMP", ["fp_reg", "fp_reg"], 2, false],
    ["FCLASS_GPR_FP", 158, "FCLASS", ["reg_gpr", "fp_reg"], 1, false],
    ["FMADD_FP_FP_ADDR", 159, "FMADD", ["fp_reg", "fp_reg", "mem"], 4, true],
    ["FMADD_FP_FP_REGADDR", 160, "FMADD", ["fp_reg", "fp_reg", "regaddr"], 4, true],
    ["FMOV_FP_IMM8", 161, "FMOV", ["fp_reg", "fp_imm8"], 1, false],
    ["FMOV_FP_IMM16", 162, "FMOV", ["fp_reg", "fp_imm16"], 1, false],
];

export const ISA_VU_DATA = [
    ["VSET_IMM16", 163, "VSET", ["imm", "fp_imm16"], 1, false],
    ["VSET_GPR", 164, "VSET", ["imm", "imm"], 1, false],
    ["VSET_MEM", 165, "VSET", ["imm", "imm"], 1, false],
    ["VSET_MEMI", 166, "VSET", ["imm", "imm"], 1, false],
    ["VFSTAT", 167, "VFSTAT", ["imm"], 1, false],
    ["VFCLR", 168, "VFCLR", [], 1, false],
    ["VWAIT", 169, "VWAIT", [], 1, false],
    ["VADD", 170, "VADD", ["imm", "imm"], 1, false],
    ["VSUB", 171, "VSUB", ["imm", "imm"], 1, false],
    ["VMUL", 172, "VMUL", ["imm", "imm"], 1, false],
    ["VDIV", 173, "VDIV", ["imm", "imm"], 1, false],
    ["VMAX", 174, "VMAX", ["imm", "imm"], 1, false],
    ["VMIN", 175, "VMIN", ["imm", "imm"], 1, false],
    ["VDOT", 176, "VDOT", ["imm", "imm"], 1, false],
    ["VSQRT", 177, "VSQRT", ["imm", "imm"], 1, false],
    ["VNEG", 178, "VNEG", ["imm", "imm"], 1, false],
    ["VABS", 179, "VABS", ["imm", "imm"], 1, false],
    ["VCMP", 180, "VCMP", ["imm", "imm", "imm"], 1, false],
    ["VSEL", 181, "VSEL", ["imm", "imm"], 1, false],
    ["VMOV", 182, "VMOV", ["imm", "imm"], 1, false],
    ["VCVT", 183, "VCVT", ["imm", "imm", "imm"], 1, false],
    ["VGATHER", 184, "VGATHER", ["imm", "imm"], 1, false],
    ["VSCATTER", 185, "VSCATTER", ["imm", "imm"], 1, false],
    ["VFMADD", 186, "VFMADD", ["imm", "imm"], 1, false],
    ["VEXP", 187, "VEXP", ["imm", "imm"], 1, false],
];

export const ISA_MU_DATA = [
    ["MSET_IMM16", 188, "MSET", ["imm", "fp_imm16"], 1, false],
    ["MSET_GPR", 189, "MSET", ["imm", "imm"], 1, false],
    ["MFSTAT", 190, "MFSTAT", ["imm"], 1, false],
    ["MFCLR", 191, "MFCLR", [], 1, false],
    ["MWAIT", 192, "MWAIT", [], 1, false],
    ["MMUL", 193, "MMUL", ["imm", "imm"], 1, false],
    ["MMAD", 194, "MMAD", ["imm", "imm"], 1, false],
];

// ── FP register data ─────────────────────────────────────────────────
// Each entry: [phys, pos, fmt_code, width]

export const FP_REG_DATA = Object.freeze({
    FA: [0, 0, 0, 32],
    FHA: [0, 0, 1, 16],
    FHB: [0, 1, 1, 16],
    FQA: [0, 0, 3, 8],
    FQB: [0, 1, 3, 8],
    FQC: [0, 2, 3, 8],
    FQD: [0, 3, 3, 8],
    FOA: [0, 0, 5, 4],
    FOB: [0, 1, 5, 4],
    FOC: [0, 2, 5, 4],
    FOD: [0, 3, 5, 4],
    FOE: [0, 4, 5, 4],
    FOF: [0, 5, 5, 4],
    FOG: [0, 6, 5, 4],
    FOH: [0, 7, 5, 4],
    FB: [1, 0, 0, 32],
    FHC: [1, 0, 1, 16],
    FHD: [1, 1, 1, 16],
    FQE: [1, 0, 3, 8],
    FQF: [1, 1, 3, 8],
    FQG: [1, 2, 3, 8],
    FQH: [1, 3, 3, 8],
    FOI: [1, 0, 5, 4],
    FOJ: [1, 1, 5, 4],
    FOK: [1, 2, 5, 4],
    FOL: [1, 3, 5, 4],
    FOM: [1, 4, 5, 4],
    FON: [1, 5, 5, 4],
    FOO: [1, 6, 5, 4],
    FOP: [1, 7, 5, 4],
});

// ── Mnemonic aliases ─────────────────────────────────────────────────

export const MNEMONIC_ALIASES = Object.freeze({
    JB: "JC",
    JNAE: "JC",
    JNB: "JNC",
    JAE: "JNC",
    JE: "JZ",
    JNE: "JNZ",
    JNBE: "JA",
    JBE: "JNA",
    SAL: "SHL",
    SAR: "SHR",
});
